export default {
  path: 'scenarios',
  component: () => import(/* webpackChunkName: "financial-predictions-scenarios" */ './Scenarios'),
  meta: { requiresAuth: true }
}
